import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { BASE_URL, fotoUrl } from '../api';
import { useOkunmamisSayisi } from '../hooks/useOkunmamisSayisi';
import { useTheme } from '../contexts/ThemeContext';

export default function EgitmenLayout({ children }: { children: React.ReactNode }) {
  const { kullanici, cikisYap, impersonating } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const okunmamis = useOkunmamisSayisi();
  const { isDark } = useTheme();

  const card   = isDark ? '#1a1a1a' : 'white';
  const border = isDark ? '#2a2a2a' : '#eee';
  const bg     = isDark ? '#0e0e0e' : '#f5f5f5';
  const textSec = isDark ? '#999' : '#555';

  return (
    <div style={{ minHeight: '100vh', background: bg, fontFamily: 'sans-serif', paddingTop: impersonating ? 40 : 0 }}>
      <div style={{ background: card, borderBottom: `1px solid ${border}`, padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: '#534AB7', letterSpacing: -0.3 }}>istanbulTANGO</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {kullanici?.foto_url
            ? <img src={fotoUrl(kullanici.foto_url)} alt="" style={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover' }} />
            : <div style={{ width: 30, height: 30, borderRadius: '50%', background: isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#534AB7' }}>
                {kullanici?.ad?.charAt(0)}
              </div>
          }
          <span style={{ fontSize: 13, color: textSec }}>{kullanici?.ad}</span>
          <span style={{ fontSize: 11, background: isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', color: '#534AB7', borderRadius: 20, padding: '2px 8px' }}>Eğitmen</span>
          <button onClick={() => navigate('/takvim')} style={{ border: `1px solid ${border}`, background: location.pathname === '/takvim' ? (isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE') : card, padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, color: '#534AB7', marginLeft: 4 }}>
            📆 Takvim
          </button>
          <button onClick={() => navigate('/mesajlar')} style={{ border: `1px solid ${border}`, background: location.pathname === '/mesajlar' ? (isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE') : card, padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, color: '#534AB7', marginLeft: 4, position: 'relative', display: 'flex', alignItems: 'center', gap: 6 }}>
            ✉ Mesajlar
            {okunmamis > 0 && (
              <span style={{ background: '#e24b4a', color: 'white', borderRadius: 20, padding: '1px 6px', fontSize: 10, fontWeight: 700 }}>
                {okunmamis > 99 ? '99+' : okunmamis}
              </span>
            )}
          </button>
          <button onClick={cikisYap} style={{ border: `1px solid ${border}`, background: card, padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, color: isDark ? '#999' : '#888', marginLeft: 4 }}>
            Çıkış
          </button>
        </div>
      </div>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>{children}</div>
    </div>
  );
}
